module.exports = __webpack_public_path__ + "back-end-services.19cqibT9.svg";